S.mainteaser = {
    config: {
        model: null,
        filter: null,
        swiper: null,
        page: null,
    },
    elements:
        {
            $more: null,
            $mainteaserElement: null,
            $filter: null,
            $main: null,
        },
    $page: null,
    $url: '/api/more.json',

    init()
    {
        this.$page = this.config.page;
        const url = window.location.pathname;

        //  german site language
        if (url.includes('/de/'))
        {
            this.$url = '/de' + this.$url
        }

        this.showMore();
        this.filterElements();
        this.checkElementsHeadline();
        if (this.config.swiper)
        {
            this.initSwiper();
        }
    },
    showMore()
    {
        this.elements.$more.on('click', () =>
        {
            this.doRequest();
            this.$page++;
            document.cookie = `page_${this.config.model}=` + this.$page
        });
    },
    filterElements()
    {
        this.elements.$filter.on('click', (e) =>
        {
            this.elements.$filter.children().removeClass('is-active');
            $(e.target).addClass('is-active');
            this.elements.$mainteaserElement.addClass('is-hidden');
            this.$module.find('.js-mainteaser-element[data-id="' + $(e.target).data('id') + '"]').removeClass('is-hidden');
            this.checkElementsHeadline();
        });
    },

    checkElementsHeadline()
    {
        this.elements.$mainteaserElement.each((index, el) =>
        {
            if ($(el).find('h3')[0].offsetHeight <= $(el).find('h3')[0].scrollHeight)
            {
                $(el).find('h3').addClass('is-long');
            }
        });
    },

    doRequest()
    {
        $.ajax({
            type: 'POST',
            url: this.$url,
            dataType: 'json',
            data: {
                'tx_projectsasi_ajax[offset]': this.$page,
                'tx_projectsasi_ajax[model]': this.config.model,
                'tx_projectsasi_ajax[filter]': this.config.filter ? $.parseJSON(this.config.filter) : null
            },

            // Success state
            success: (data) =>
            {
                this.elements.$main.append(data.html);
                if (!data.showMore)
                {
                    this.elements.$more.remove();
                }
            },

            // Error state
            error: (e) =>
            {
                console.log(e);
            },
        });
    },
    initSwiper()
    {
        // get area-label Text Arrows (prevSlideMessage/nextSlideMessage)
        const slideMessageArray = S.swiperset.getSlideMessage(this.config.language);

        // https://swiperjs.com/swiper-api
        this.$swiper = new Swiper(this.elements.$swiperContainer.get(0), {
            slidesPerView: 1,
            // slidesPerGroup: 3,
            breakpoints: {
                // when window width is >= 768px
                768: {
                    slidesPerView: 2,
                    spaceBetween: 40
                },
                // when window width is >= 1024px
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 40
                }
            },

            speed: this.config.speed,
            centeredSlides: false,
            centerInsufficientSlides: true,
            loop: this.config.loop,
            // calculateHeight: true,
            // https://swiperjs.com/swiper-api#param-preventClicks
            // https://swiperjs.com/swiper-api#param-preventClicksPropagation
            // wenn Bild nicht verlinkt auf false setzen
            // Barrierefreiheit sonst Image im Screenreader verlinkt
            preventClicks: false,
            preventClicksPropagation: false,

            // 7.0.0 +
            // Enable this feature to calculate each slides progress and visibility (slides in viewport will have additional visible class)
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            preloadImages: false,
            lazy: true,


            // autoplay: {
            //     delay: 3000,
            // },

            keyboard: {
                enabled: true,
            },

            // pagination optional
            pagination: {
                el: this.$module.find('.swiper-pagination').get(0),
                clickable: true,
                // type: 'fraction',
            },

            navigation: {
                nextEl: this.$module.find('.swiper-button-next').get(0),
                prevEl: this.$module.find('.swiper-button-prev').get(0),
            },

            a11y: {
                prevSlideMessage: slideMessageArray['prev'],
                nextSlideMessage: slideMessageArray['next'],
            },

            on: {
                init: () =>
                {
                    // remove double iDs
                    S.swiperset.removeDuplicateId();
                },

                slideChange: () =>
                {
                    // stop video/audio
                    S.swiperset.resetsrc(this.$module);
                },
            },
        });
    },
};
